import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IBrowserNotSupportedStore} from './browser-not-supported.stores';
import {IAppRootStore} from '../../app.root.store';
import BrowserNotSupportedLayoutComponent from './components/layout/index';

import '@techsee/techsee-ui-common/lib/_shared/icons.css';
import './components/layout/styles.scss';

interface BrowserNotSupportedViewProps {
    browserNotSupportedStore: IBrowserNotSupportedStore;
    rootStore: IAppRootStore;
}

@observer
export class BrowserNotSupportedViewComponent extends TechseeBaseComponent<BrowserNotSupportedViewProps> {
    renderInternal(): JSX.Element {
        return (
            <BrowserNotSupportedLayoutComponent
                browserNotSupportedController={this.props.browserNotSupportedStore.browserNotSupportedController}
            />
        );
    }
}

export const BrowserNotSupportedView = inject(
    'rootStore',
    'browserNotSupportedStore'
)(BrowserNotSupportedViewComponent) as IReactComponent;
